import { connect } from 'react-redux'
import { getHouseTypeRoot } from '../../houseType/selectors'
import AdminHouseType from '../components/adminHouseType'

const mapStateToProps = state => ({
  rootNode: getHouseTypeRoot(state),
  config: {
    create: [
      {
        action: 'neuer Haustyp',
        mutation: 'createListMutation',
        res: 'createList',
        variables: id => ({
          list: {
            template: 'Slider',
            title: 'neuer Haustyp',
            parent: id,
          },
        }),
      },
      {
        action: 'neuer Grundriss',
        mutation: 'createOptionGroupMutation',
        res: 'createOptionGroup',
        variables: id => ({
          optionGroup: {
            elements: [{ title: 'neues Element' }],
            title: 'neuer Grundriss',
            parent: id,
          },
        }),
      },
    ],
    drag: {
      List: {
        mutation: 'updateListMutation',
        variables: (id, children) => ({
          list: {
            id,
            children,
          },
        }),
      },
      Root: {
        mutation: 'updateRootMutation',
        variables: (id, children) => ({
          root: {
            id,
            children,
          },
        }),
      },
    },
  },
})

export default connect(
  mapStateToProps,
  null,
)(AdminHouseType)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminHouseType.js